import React, { useEffect, useState } from "react"; 
import {
  Grid,
  TextField,
  Typography,
  Card,
  CardContent,
  Avatar,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import { getDoc, doc, updateDoc } from "firebase/firestore"; // Import updateDoc
import { db } from "../../../firebase";
import { useLocation } from "react-router-dom";

const Fullview = () => {
  const [message, setMessage] = useState({});
  const [updatedMessage, setUpdatedMessage] = useState({}); // State for updated message
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const giftid = params.get("uid");
    if (giftid) {
      fetchMessage(giftid);
    }
  }, [location.search]);

  const fetchMessage = async (giftid) => {
    try {
      const docRef = doc(db, "prizepoll", giftid);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const messageData = docSnap.data();
        messageData.createdAt = new Date(messageData.createdAt);
        setMessage(messageData);
        setUpdatedMessage(messageData); // Set initial values for editing
      } else {
        console.log("No such document!");
      }
    } catch (error) {
      console.error("Error fetching message:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdatedMessage((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdate = async () => {
    const docRef = doc(db, "prizepoll", message.id); // Use the correct document reference
    
    // Create an object to hold the updated data
    const updatedData = { ...updatedMessage };
  
    // Ensure createdAt is a valid date before updating
    if (updatedMessage.createdAt instanceof Date && !isNaN(updatedMessage.createdAt)) {
      updatedData.createdAt = updatedMessage.createdAt.toISOString(); // Convert to ISO string if valid
    } else {
      delete updatedData.createdAt; // Remove invalid date field
    }
  
    try {
      await updateDoc(docRef, updatedData);
      setAlertMessage("Update successful!");
      setAlertSeverity("success");
    } catch (error) {
      console.error("Error updating document:", error);
      setAlertMessage("Error updating document!");
      setAlertSeverity("error");
    }
    setShowAlert(true);
  };
  

  const handleCloseAlert = () => {
    setShowAlert(false);
  };

  return (
    <div className="App">
      <main style={{ padding: "20px 5px" }}>
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={10} md={8} lg={6}>
            <Avatar
              alt={message.gift_name || "User"}
              src={message.image || "/placeholder.jpg"}
              style={{
                width: 100,
                height: 100,
                margin: "0 auto",
                marginBottom: 20,
              }}
            />
            <Card style={{ margin: "0 auto" }}>
              <CardContent>
                <Typography
                  variant="h6"
                  color="#272727"
                  align="center"
                  gutterBottom
                >
                  Gift Details
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      label="ID"
                      name="id"
                      value={message.id || ""}
                      fullWidth
                      variant="outlined"
                      disabled
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      label="Position"
                      name="position"
                      value={updatedMessage.position || ""}
                      fullWidth
                      variant="outlined"
                      onChange={handleChange} // Handle changes
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      label="Amount"
                      name="amount"
                      value={updatedMessage.amount || ""}
                      fullWidth
                      variant="outlined"
                      onChange={handleChange} // Handle changes
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Gift Name"
                      name="gift_name"
                      value={updatedMessage.gift_name || ""}
                      fullWidth
                      variant="outlined"
                      onChange={handleChange} // Handle changes
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Contest Id"
                      name="contest_id"
                      value={updatedMessage.contest_id || ""}
                      fullWidth
                      variant="outlined"
                      onChange={handleChange} // Handle changes
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleUpdate} // Update button click handler
                    >
                      Update
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <Snackbar open={showAlert} autoHideDuration={6000} onClose={handleCloseAlert}>
              <Alert onClose={handleCloseAlert} severity={alertSeverity}>
                {alertMessage}
              </Alert>
            </Snackbar>
          </Grid>
        </Grid>
      </main>
    </div>
  );
};

export default Fullview;
